console.log(`Loading config for ${process.env.REACT_APP_ENVIRONMENT} environment...`)

const googleOAuthClientId = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID
if (!googleOAuthClientId) {
  console.error('FATAL: REACT_APP_GOOGLE_OAUTH_CLIENT_ID is not set.')
  process.exit(1)
}

const backendUrl = process.env.REACT_APP_BACKEND_URL
if (!backendUrl) {
  console.error('FATAL: REACT_APP_BACKEND_URL is not set.')
  process.exit(1)
}

const nativeAppScheme = process.env.REACT_APP_NATIVE_APP_SCHEME
if (!nativeAppScheme) {
  console.error('FATAL: REACT_APP_NATIVE_APP_SCHEME is not set.')
  process.exit(1)
}

const oauthCallbackPath = process.env.REACT_APP_OAUTH_CALLBACK_PATH
if (!oauthCallbackPath) {
  console.error('FATAL: REACT_APP_OAUTH_CALLBACK_PATH is not set.')
  process.exit(1)
}

const firebaseApiKey = process.env.REACT_APP_FIREBASE_API_KEY
if (!firebaseApiKey) {
  console.error('FATAL: REACT_APP_FIREBASE_API_KEY is not set.')
  process.exit(1)
}

const firebaseAuthDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN
if (!firebaseAuthDomain) {
  console.error('FATAL: REACT_APP_FIREBASE_AUTH_DOMAIN is not set.')
  process.exit(1)
}

const firebaseProjectId = process.env.REACT_APP_FIREBASE_PROJECT_ID
if (!firebaseProjectId) {
  console.error('FATAL: REACT_APP_FIREBASE_PROJECT_ID is not set.')
  process.exit(1)
}

interface AppConfig {
  // port: number
  googleOAuthClientId: string
  backendUrl: string
  nativeAppScheme: string
  oauthCallbackPath: string
  firebaseApiKey: string
  firebaseAuthDomain: string
  firebaseProjectId: string
}

export const config: AppConfig = {
  // port: parseInt(process.env.PORT || '3006', 10),
  googleOAuthClientId: googleOAuthClientId,
  backendUrl: backendUrl,
  nativeAppScheme: nativeAppScheme,
  oauthCallbackPath: oauthCallbackPath,
  firebaseApiKey: firebaseApiKey,
  firebaseAuthDomain: firebaseAuthDomain,
  firebaseProjectId: firebaseProjectId,
}
